<script setup lang="ts">
type StoreLinksProps = {
  store: SFCCStore
  position: number
  hideDirections?: boolean
}

const props = defineProps<StoreLinksProps>()
const emit = defineEmits(['datalayer-click'])

const googleMapsDirectionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${props.store.latitude},${props.store.longitude}`
</script>

<template>
  <div class="store-links">
    <Anchor
      class="store-links__book-appointment"
      variant="text"
      v-if="store.c_bookAppointmentLink"
      :url="store.c_bookAppointmentLink"
      @click="
        emit('datalayer-click', {
          label: $t('product_details_page.find_store.popup.button_book_appointment'),
          url: store.c_bookAppointmentLink,
        })
      "
    >
      <svg-icon name="mhj:book-appointment" class="store-links__book-appointment__icon" />
      {{ $t('product_details_page.find_store.popup.button_book_appointment') }}
    </Anchor>
    <Anchor
      class="store-links__directions"
      variant="text"
      v-if="store.name && !hideDirections"
      :url="googleMapsDirectionsUrl"
      :new-tab="true"
      @click="
        emit('datalayer-click', {
          label: $t('product_details_page.find_store.popup.button_get_directions'),
          url: googleMapsDirectionsUrl,
        })
      "
    >
      <svg-icon name="mhj:directions" class="store-links__directions__icon" />
      {{ $t('product_details_page.find_store.popup.button_get_directions') }}
    </Anchor>
  </div>
</template>

<style lang="postcss">
.store-links {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-50);
  pointer-events: auto;

  .store-links__book-appointment,
  .store-links__directions {
    display: flex;
    align-items: center;
    &:hover {
      text-decoration: underline;
      color: var(--text-link-hover);
    }
    .store-links__book-appointment__icon {
      margin-right: var(--space-10);
    }
    .store-links__directions__icon {
      margin-right: var(--space-30);
      width: 20px;
      height: 20px;
    }
  }
}
</style>
